// Escurecimento das salas de projeto vazias, suave: a sala escurece aos poucos quando passa de
// DARK_AFTER_MS sem ninguém (regra de isRoomDark, em behavior.ts) e clareia aos poucos quando
// alguém entra. Puro: o campus guarda o nível de cada sala e chama aproximaEscuro a cada quadro.

/** Quanto tempo leva para escurecer (ou clarear) por inteiro, em ms. */
export const DARK_FADE_MS = 1500;

/**
 * Próximo nível de escuro (0 = luz acesa, 1 = apagada) depois de `dt` ms, indo na direção de
 * `alvo`. Sobe e desce na mesma velocidade e não passa do alvo.
 */
export function aproximaEscuro(atual: number, alvo: 0 | 1, dt: number): number {
  const passo = Math.max(0, dt) / DARK_FADE_MS;
  if (atual < alvo) return Math.min(alvo, atual + passo);
  return Math.max(alvo, atual - passo);
}
